import React, { useContext } from "react";
import { FaCheckDouble, FaDatabase, FaClipboardCheck, FaShieldAlt } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import '../Audit/AuditGlobal.css';
import BannerImage from '../../assets/core_services/tank_inspection_hero_1776820154935.png';

function TankInspection() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/tank-inspection');
    } else {
      navigate('/login', { state: { from: '/booking/tank-inspection' } });
    }
  };

  return (
    <div className="audit-page">
      <div className="audit-max-width">

        {/* --- HERO --- */}
        <div className="audit-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Core Services</span>
          <h1 className="hero-title">Tank & Vessel Inspection</h1>
          <p className="hero-subtitle">
            Comprehensive testing and certification for storage tanks and pressure vessels to prevent leaks, failures, and environmental hazards.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Enquire Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Mitigating Catastrophic Risk</h2>
              <p className="article-text">
                Storage tanks and pressure vessels hold volatile, hazardous, or high-pressure substances. Routine inspection is crucial to identify corrosion, structural weaknesses, and potential leakage points before they result in catastrophic industrial accidents or environmental damage.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Our Comprehensive Methodology</h2>
              <p className="article-text">
                Our API-certified inspectors utilize advanced methodologies:
                <br />- <strong>Hydrostatic & Pneumatic Testing:</strong> To verify integrity under pressure.
                <br />- <strong>Thickness Measurement:</strong> Using UT to assess corrosion rates and remaining life.
                <br />- <strong>Visual & Internal Inspection:</strong> Confined space entry for detailed evaluation of linings, welds, and structure.
                <br />- <strong>Leak Detection:</strong> Using vacuum boxes and advanced leak testing equipment.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Extend Asset Lifespan</h2>
              <p className="article-text">
                Through regular inspection and predictive maintenance recommendations, we not only ensure compliance with API and ASME standards but also significantly extend the operational lifespan of your critical assets.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Inspection Focus</h4>
              <ul className="key-list">
                <li><FaShieldAlt className="check-icon" /> Leak Prevention</li>
                <li><FaDatabase className="check-icon" /> Pressure Integrity</li>
                <li><FaClipboardCheck className="check-icon" /> API/ASME Compliance</li>
                <li><FaCheckDouble className="check-icon" /> Asset Longevity</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Inspect Your Tanks</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Ensure your vessels are safe and compliant today.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Inspection
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default TankInspection;
